export default "skymp5-front/e8fceea362a66a8c0c04c29afa5271e0.png";